<!-- メール設定コンポーネント -->
<template>
    <div class="regist mailSetting">
        <form method="post" ref="emailSettingForm" @submit.prevent="submit">
            <input :value="dataCsrf"
                   :name="dataCsrfName"
                   type="hidden">
            <input :value="dataToken"
                   name="token"
                   type="hidden">
            <input v-model="jsonPatchForUserInfo"
                   name="userinfo_patch"
                   type="hidden">

            <h2>
                <img :src="emblemImagePath" alt="">
                {{ mailSettingClubTeam.teamName }}からのメール設定
            </h2>

            <ul v-if="isClubTeam" class="recieve">
                <li>
                    <label tabindex="0" @keydown.enter="changeAcceptFlag('acceptFlag')">
                        <input v-model="targetContactCode.acceptFlag"
                               type="checkbox">
                        <i></i>クラブからのお知らせ
                    </label>
                </li>
            </ul>
            <ul v-else class="recieve">
                <li>
                    <label tabindex="0" @keydown.enter="changeAcceptFlag('acceptFlag')">
                        <input v-model="targetContactCode.acceptFlag"
                               type="checkbox">
                        <i></i>Ｊリーグからのお知らせ
                    </label>
                </li>
                <li>
                    <label tabindex="0"  @keydown.enter="changeAcceptFlag('storeAcceptFlag')">
                        <input v-model="targetContactCode.storeAcceptFlag"
                               type="checkbox">
                        <i></i>Ｊリーグオンラインストアからのお知らせ
                    </label>
                </li>
            </ul>

            <p class="notice">※ 重要なお知らせにつきましては、許諾にかかわらずお届けいたします。</p>

            <div class="btnSpace duo">
                <button @click="backToHome"
                        type="button"
                        class="return">メニューに戻る</button>
                <button type="submit">登録</button>
            </div>
        </form>
    </div>
</template>

<script>
import jsonpatch from 'fast-json-patch'
import { mixinJleague, mixinFavoriteClub, EnumContactCode } from '../mixin/utility'

const CLUB_CODE_PARAM_KEY = 'club_cd';
const JLEAGUE_SETTINGS = {
    clubCode: 'JL',
    teamName: 'Ｊリーグ',
    emblemImg: 'embJleague.png',
    shortName: '',
    league: '',
};
Object.freeze(JLEAGUE_SETTINGS);

export default {
    name: 'EmailSetting',
    mixins: [mixinJleague, mixinFavoriteClub],
    data: function(){
        return {
            userInfoPatch: {},
            jsonPatchObserver: {},
            jsonPatchForUserInfo: '',
            targetContactCode: {}
        }
    },
    props: {
        dataCsrf: {
            type: String,
            required: true
        },
        dataCsrfName: {
            type: String,
            required: true
        },
        dataToken: {
            type: String,
            required: true
        },
        userinfo: {
            type: Object,
            required: true
        }
    },
    computed: {
        clubCode: function(){
            return this.getUrlParamByKey(location.href, CLUB_CODE_PARAM_KEY);
        },
        isClubTeam: function(){
            const clubCode = this.clubCode;
            if (clubCode === JLEAGUE_SETTINGS.clubCode) return false;

            // jleagueClubList に存在しない clubCode ときはＪリーグとして扱う
            return this.allClubTeams.some(function(element){
                return clubCode === element.clubCode;
            });
        },
        mailSettingClubTeam: function(){
            const clubCode = this.clubCode;
            if (this.isClubTeam){
              return this.allClubTeams.find(function(clubTeam){
                return clubTeam.clubCode === clubCode;
              });
            }else{
              if(clubCode === 'JL'){
                return JLEAGUE_SETTINGS;
              }else{
                location.href = '/error?path=change-userinfo&error_code=404';
              }
            }
        },
        emblemImagePath: function(){
            return 'https://auth2.jleague.jp/emblem/' + this.mailSettingClubTeam.emblemImg;
        },
        favoriteClubs: {
            set: function(value){
                if (typeof value === 'string'){
                    this.userInfoPatch.club_cd = value;
                }else{
                    this.userInfoPatch.club_cd = value.toString();
                }
            },
            get: function(){
                var clubs = [];
                if (typeof this.userInfoPatch.club_cd === 'string'){
                    clubs = this.userInfoPatch.club_cd.split(',');
                }else{
                    clubs = this.userInfoPatch.club_cd;
                }
                return clubs;
            }
        },
        contactCodeToArray: function(){
            const contacts = this.userInfoPatch.contact_cd;

            // `userinfo.contact_cd` が文字列のとき、配列に変換して返す
            return (typeof contacts === 'string')? [contacts]: contacts;
        },
        contactCodeObjects: function(){
            // 設定済みの承諾一覧をオブジェクトに変換して返す
            return this.contactCodeToArray.map(function(contact){
                // `=` でクラブコードとコンタクトコードに分離する
                const codes = contact.split('=');
                const key = codes[0];
                const values = codes[1].split(',');

                return {
                    clubCode: key,
                    acceptFlag: (values.indexOf(EnumContactCode.NoticeCode) !== -1),
                    storeAcceptFlag: (values.indexOf(EnumContactCode.StoreNoticeCode) !== -1)
                };
            });
        },
        contactCodes: {
            set: function(values){
                switch (values.length) {
                    case 0:
                        // 0件のときは null で登録する
                        this.userInfoPatch.contact_cd = null;
                        break;
                    case 1:
                        // 1件のときは配列ではなく文字列で登録する
                        this.userInfoPatch.contact_cd = values.toString();
                        break;
                    default:
                        // 配列で登録する
                        this.userInfoPatch.contact_cd = values;
                }
            },
            get: function(){
                return this.userInfoPatch.contact_cd;
            }
        },
        isReplace: function(){
            const clubCode = this.clubCode;

            // 設定済みの承諾一覧にクエリで指定されたクラブコードが存在するとき true
            return this.contactCodeObjects.some(function(contact){
                return clubCode === contact.clubCode;
            });
        }
    },
    created: function(){
        this.userInfoPatch = Object.assign({}, this.userinfo);
        this.jsonPatchObserver = jsonpatch.observe(this.userInfoPatch);

        if (!this.userInfoPatch.club_cd) this.userInfoPatch.club_cd = '';
        if (!this.userInfoPatch.contact_cd) this.userInfoPatch.contact_cd = [];

        const clubCode = this.clubCode;
        if (!this.isReplace) {
            this.contactCodeObjects.push({
                clubCode: clubCode,
                acceptFlag: false,
                storeAcceptFlag: false
            });
        }

        this.targetContactCode = this.contactCodeObjects.find(function(contact){
            return clubCode === contact.clubCode;
        });
    },
    methods: {
        changeAcceptFlag(property) {
            this.targetContactCode[property] = !this.targetContactCode[property];
        },
        generateJsonPatch: function(){
            const self = this;

            return new Promise(function(resolve){
                self.contactCodeObjects.sort(function(a, b){
                    if (a.clubCode < b.clubCode) return -1;
                    if (a.clubCode > b.clubCode) return 1;

                    return 0;
                });

                const contacts = self.contactCodeObjects.map(function(contact){
                    const accepts = [];

                    // メール承諾フラグをチェックする
                    if (contact.acceptFlag) accepts.push(EnumContactCode.NoticeCode);
                    if (contact.storeAcceptFlag) accepts.push(EnumContactCode.StoreNoticeCode);

                    // メール承諾ONがないとき
                    if (accepts.length === 0) return null;

                    // オブジェクトを `=` と `,` 区切りの文字列に変換して返す
                    return self.buildContactCode(contact.clubCode, accepts);
                }).filter(function(contact){
                    // null の値 (メール承諾OFF) を除外して返す
                    return contact !== null;
                });

                // メール受け取りをONにしたとき、お気に入りもONにする(JL以外)
                if (self.targetContactCode.clubCode !== "JL" && self.favoriteClubs.indexOf(self.targetContactCode.clubCode) === -1) {
                    let favoriteClubs = self.favoriteClubs
                    favoriteClubs.push(self.targetContactCode.clubCode)
                    self.userInfoPatch.club_cd = favoriteClubs.join(',')
                }
                // お気に入りが空文字になる場合はnullでリクエストする
                if (!self.userInfoPatch.club_cd){
                    self.userInfoPatch.club_cd = null;
                }
                self.contactCodes = contacts;
                let jsonPatchData = jsonpatch.generate(self.jsonPatchObserver)
                jsonPatchData.push(
                  { "op": "add", "path": "/sfdc_necessary_api_call_mode", "value": "1" },
                  { "op": "add", "path": "/sfdc_sync_contact_code", "value": "1" },
                  { "op": "add", "path": "/sfdc_sync_favorite_club", "value": "1" }
                )
                self.jsonPatchForUserInfo = JSON.stringify(jsonPatchData);
                resolve(self.jsonPatchForUserInfo);
            });
        },
        submit: async function(){
            const form = this.$refs.emailSettingForm;
            await this.generateJsonPatch();

            form.submit();
        }
    }
}
</script>
